import React, { useRef, useState, useEffect } from 'react';
import s from '../SliderBigText.module.css';
import { useParams } from "react-router-dom";
import { useAppTranslation } from "./TranslationContext";

export const SliderBigText = () => {
  const [data, setData] = useState([]);
  const { id } = useParams();
  const { t } = useAppTranslation();

  const slidesRef = useRef(null);
  const [canLeft, setCanLeft]   = useState(false);
  const [canRight, setCanRight] = useState(false);

  /* Обновляем состояние кнопок по текущей позиции скролла */
  const syncButtons = () => {
    const el = slidesRef.current;
    if (!el) return;
    setCanLeft(el.scrollLeft > 4);
    setCanRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 4);
  };

  /* Ширина одного шага = ширина первого слайда + gap */
  const getStepWidth = () => {
    const el = slidesRef.current;
    const slide = el?.querySelector(`.${s.slide}`);
    if (!slide || !el) return 300;
    const gap = parseFloat(getComputedStyle(el).columnGap) || 24;
    return slide.offsetWidth + gap;
  };

  /* Загружаем комментарии, затем данные пользователей — последовательно */
  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const res = await fetch(`https://api.aiassessment.uz/api/comment-kurs/?kurs=${id}`);
        if (!res.ok) throw new Error(res.status);
        const comments = await res.json();
        if (cancelled) return;

        // Рендерим слайды сразу с заглушками
        setData(comments.map(c => ({
          ...c,
          photo: "https://api.aiassessment.uz/media/dt_pic.jpg",
          firstName: "",
          lastName: "",
        })));

        // Получаем данные пользователей по одному, чтобы не перегружать HTTP/2
        for (let i = 0; i < comments.length; i++) {
          if (cancelled) break;
          const userId = comments[i].user;
          if (!userId) continue;

          let photo = "https://api.aiassessment.uz/media/dt_pic.jpg";
          let firstName = "";
          let lastName = "";

          try {
            const r = await fetch(`https://api.aiassessment.uz/api/custom-users/?user=${userId}`);
            if (r.ok) {
              const d = await r.json();
              photo = d?.[0]?.img || photo;
            }
          } catch {}

          try {
            const r = await fetch(`https://api.aiassessment.uz/api/users/${userId}/`);
            if (r.ok) {
              const u = await r.json();
              firstName = u?.first_name || "";
              lastName  = u?.last_name  || "";
            }
          } catch {}

          if (!cancelled) {
            setData(prev => {
              const next = [...prev];
              if (next[i]) next[i] = { ...next[i], photo, firstName, lastName };
              return next;
            });
          }
        }
      } catch {}
    };

    load();
    return () => { cancelled = true; };
  }, [id]);

  /* Синхронизируем кнопки после рендера данных */
  useEffect(() => {
    if (data.length === 0) return;
    const timer = setTimeout(syncButtons, 80);
    return () => clearTimeout(timer);
  }, [data.length]);

  const moveLeft = () => {
    const el = slidesRef.current;
    if (!el) return;
    el.scrollBy({ left: -getStepWidth(), behavior: 'smooth' });
  };

  const moveRight = () => {
    const el = slidesRef.current;
    if (!el) return;
    el.scrollBy({ left: getStepWidth(), behavior: 'smooth' });
  };

  return (
    <div className={s.slider}>
      <div className={s.slider__left__right__btn}>
        <p className={s.slider__title}>{t('commentTitle')}</p>
        <div className={s.btns}>
          <button onClick={moveLeft} disabled={!canLeft}>
            <img className={s.slider__button__prev}
              src="https://cdn-icons-png.flaticon.com/128/130/130882.png" alt="prev" />
          </button>
          <button onClick={moveRight} disabled={!canRight}>
            <img className={s.slider__button__next}
              src="https://cdn-icons-png.flaticon.com/128/130/130882.png" alt="next" />
          </button>
        </div>
      </div>

      <div className={s.slides} ref={slidesRef} onScroll={syncButtons}>
        {data.map((slide, index) => (
          <div className={s.slide} key={index}>
            <div className={s.slide__contents}>
              <p className={s.slide__text}>{slide.comment}</p>
              <div className={s.slide__jobs}>
                <p>
                  {(slide.firstName || slide.lastName)
                    ? `${slide.firstName} ${slide.lastName}`.trim()
                    : "Без имени"}
                  <span className={s.material}></span>
                  {slide.to}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
